module.exports = __webpack_public_path__ + "img/title_2.2fe6b9da.png";